export function HourglassStartRegular({ width = 16 }: { width?: number }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 640 640"
      width={width}
      fill="none"
    >
      <path
        opacity=".4"
        d="M241.9 208L398 208L319.9 286.1L241.8 208z"
        fill="currentColor"
      />
      <path
        d="M128 552C128 565.3 138.7 576 152 576L488 576C501.3 576 512 565.3 512 552C512 538.7 501.3 528 488 528L480 528L480 509C480 468.7 464 430 435.5 401.5L354 320L435.5 238.5C464 210 480 171.3 480 131L480 112L488 112C501.3 112 512 101.3 512 88C512 74.7 501.3 64 488 64L152 64C138.7 64 128 74.7 128 88C128 101.3 138.7 112 152 112L160 112L160 131C160 171.3 176 210 204.5 238.5L286 320L204.5 401.5C176 430 160 468.7 160 509L160 528L152 528C138.7 528 128 538.7 128 552zM241.9 208L398 208L319.9 286.1L241.8 208zM212.1 160C209.4 150.7 208 140.9 208 131L208 112L432 112L432 131C432 140.9 430.6 150.7 427.9 160L212.1 160zM401.5 435.5C421 455 432 481.4 432 509L432 528L208 528L208 509C208 481.4 219 455 238.5 435.5L320 354L401.5 435.5z"
        fill="currentColor"
      />
    </svg>
  );
}
